$(function() {
  $('.removewrap-padd_top').each(function(i, obj) {
  	$(this).closest('.shopify-section').addClass('nopadd-top');
  });
  $('.removewrap-padd_bottom').each(function(i, obj) {
  	$(this).closest('.shopify-section').addClass('nopadd-bottom');
  });
  
  
  $(document).on('click', '.colpsebtn', function(){
    if ( $(this).hasClass('col-open') ) {
      $(this)
      	.removeClass('col-open')
      	.find('i.fa')
      	.removeClass('fa-angle-down')
      	.addClass('fa-angle-right');
       $(this).closest('.collapse-show').find('ul.site-footer__linklist').slideUp();
    } else {
      $(this)
      	.addClass('col-open')
      	.find('i.fa')
      	.removeClass('fa-angle-right')
      	.addClass('fa-angle-down');
      
      $(this).closest('.collapse-show').find('ul.site-footer__linklist').slideDown();
    }
  })
  
  $(document).on('click', '.relem', function(){
    var targData = $(this).find("input").attr("class");
    $(this).find("input").prop("checked", true).hide();;
  	$( '.optTrig' ).hide();
    $( '.el-' + targData ).show();
    
    $(".next").trigger('click');
    
  })
  
})



//jQuery time
var current_fs, next_fs, previous_fs, last_fs; //fieldsets
var left, opacity, scale; //fieldset properties which we will animate
var animating; //flag to prevent quick multi-click glitches

$(".next").click(function(){
	if(animating) return false;
	animating = true;
  	var chk_cus = $('#chck_login').val();
  
    if ( $(this).val() == "In-Store" ) {
      $('.booking-instore, .booking-online').hide();
      $('.booking-instore').show();
    } else if ( $(this).val() == "Online" ) {
      $('.booking-instore, .booking-online').hide();
      $('.booking-online').show();
    }
  
	
	current_fs = $(this).parent();
	next_fs = $(this).parent().next();
	
	//activate next step on progressbar using the index of next_fs
	$("#progressbar li").eq($("fieldset").index(next_fs)).addClass("active");
	
	//show the next fieldset
	next_fs.show(); 
	//hide the current fieldset with style
	current_fs.animate({opacity: 0}, {
		step: function(now, mx) {
			scale = 1 - (1 - now) * 0.2;
			left = (now * 50)+"%";
			opacity = 1 - now;
			current_fs.css({
              'transform': 'scale('+scale+')',
              'position': 'absolute'
            });
			next_fs.css({'left': left, 'opacity': opacity});
		}, 
		duration: 800, 
		complete: function(){
			current_fs.hide();
			animating = false;
          	current_fs.css({
              'position': 'relative'
            });
		}, 
		easing: 'easeInOutBack'
	});
});

$(".previous").click(function(){
	if(animating) return false;
	animating = true;
	
	current_fs = $(this).parent();
	previous_fs = $(this).parent().prev();
	
	//de-activate current step on progressbar
	$("#progressbar li").eq($("fieldset").index(current_fs)).removeClass("active");
	
	//show the previous fieldset
	previous_fs.show(); 
	//hide the current fieldset with style
	current_fs.animate({opacity: 0}, {
		step: function(now, mx) {
			scale = 0.8 + (1 - now) * 0.2;
			left = ((1-now) * 50)+"%";
			opacity = 1 - now;
			current_fs.css({'left': left});
			previous_fs.css({'transform': 'scale('+scale+')', 'opacity': opacity});
		}, 
		duration: 800, 
		complete: function(){
			current_fs.hide();
			animating = false;
		}, 
		//this comes from the custom easing plugin
		easing: 'easeInOutBack'
	});
});

$( '.consulform' ).on('click', function(){
  	var prodname = $(this).data('title');
  	$('#msform-other-servics').val(prodname);
	$('#formBooking').fadeIn();
  	$('body').addClass('noscroll');
})

$( '.formClose, .home' ).on('click', function(){
	$('#formBooking').fadeOut();
  	$('body').removeClass('noscroll');
})


$(".submit").click(function(){
	return false;
})

$('.submitForm').on('click', function(){
  var em = $(this);
  var $form = $("#msform");
  jQuery.ajax({
    type: 'POST',
    async: true,
    url: '/contact',
    data: $form.serialize(), 
    success: function(data) {
      
        if(animating) return false;
        animating = true;
      
		current_fs 	= em.parent();
		last_fs 	= em.parent().last();
      
    	last_fs.show(); 
      	current_fs.animate({opacity: 0}, {
          step: function(now, mx) {
              scale = 1 - (1 - now) * 0.2;
              left = (now * 50)+"%";
              opacity = 1 - now;
              current_fs.css({
                'transform': 'scale('+scale+')',
                'position': 'absolute'
              });
              last_fs.css({'left': left, 'opacity': opacity});
          }, 
          duration: 800, 
          complete: function(){
              current_fs.hide();
              animating = false;
              current_fs.css({
                'position': 'relative'
              });
          }, 
          easing: 'easeInOutBack'
      });
      
      $('.thankyou_').fadeIn();
    }
  });
})


// wshlst
setTimeout(function(){
  $(".swym-button-bar").appendTo(".wshlst");
}, 1000);


var slider = document.getElementById("budget_range");
var output = document.getElementById("msform-budget");
output.innerHTML = slider.value;

slider.oninput = function() {
  output.value = this.value;
}